import type { ReactNode } from 'react';

import { cn } from '../lib/utils';

interface FormCardProps {
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}

/** Vertical stack that lays out the section cards in FormPage, keeping a
 * consistent gap between them. The footer renders as its own bottom card. */
export function FormCard({ children, footer, className }: FormCardProps) {
  return (
    <div className={cn('flex flex-col gap-6', className)}>
      {children}

      {footer ? (
        <div className="flex flex-wrap items-center justify-end gap-2 rounded-md border border-border bg-card px-5 py-4">
          {footer}
        </div>
      ) : null}
    </div>
  );
}
